exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".my-custom-scrollbar{position:relative;height:550px;overflow:auto}.table-wrapper-scroll-y{display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7b3281a4","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/allModuleForm/filterCBModal.vue
// module id = 1717
// module chunks = 0